module.exports = __webpack_public_path__ + "img/nav-segments.275c641d.svg";